import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import AdSensePlugin from './plugins/adsense'
import { adSenseConfig, isAdSenseEnabled } from './config/adsense'
import { trackPageView } from './config/analytics'
import './assets/tailwind.css'

router.afterEach((to) => {
  trackPageView(to.fullPath)
})

// Inicializar modo oscuro
function initializeDarkMode() {
  const savedMode = localStorage.getItem('darkMode')
  if (savedMode === 'true') {
    document.documentElement.classList.add('dark')
  } else if (savedMode === null) {
    // Detectar preferencia del sistema si no hay preferencia guardada
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.classList.add('dark')
    }
  }
}

// Ejecutar antes de montar la aplicación
initializeDarkMode()

const app = createApp(App)

// Configurar AdSense solo si está habilitado
if (isAdSenseEnabled()) {
  app.use(AdSensePlugin, {
    clientId: adSenseConfig.clientId
  })
}

app.use(router).use(i18n).mount('#app')
